import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import { Protected } from "@/components/Protected";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminClientDetail from "@/pages/AdminClientDetail";
import AdminSettings from "@/pages/AdminSettings";
import AdminTemplates from "@/pages/AdminTemplates";
import AdminRevenue from "@/pages/AdminRevenue";
import AdminTasks from "@/pages/AdminTasks";
import AdminProjects from "@/pages/AdminProjects";
import AdminActionQueue from "@/pages/AdminActionQueue";
import AdminAppointments from "@/pages/AdminAppointments";
import AdminNotifications from "@/pages/AdminNotifications";
import ClientNotificationsPage from "@/pages/ClientNotificationsPage";

function RootRedirect() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Landing />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}

function RouteSwitch() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<Protected role="client"><ClientDashboard /></Protected>} />
      <Route path="/notifications" element={<Protected role="client"><ClientNotificationsPage /></Protected>} />
      <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
      <Route path="/admin/notifications" element={<Protected role="admin"><AdminNotifications /></Protected>} />
      <Route path="/admin/templates" element={<Protected role="admin"><AdminTemplates /></Protected>} />
      <Route path="/admin/revenue" element={<Protected role="admin"><AdminRevenue /></Protected>} />
      <Route path="/admin/tasks" element={<Protected role="admin"><AdminTasks /></Protected>} />
      <Route path="/admin/projects" element={<Protected role="admin"><AdminProjects /></Protected>} />
      <Route path="/admin/queue" element={<Protected role="admin"><AdminActionQueue /></Protected>} />
      <Route path="/admin/appointments" element={<Protected role="admin"><AdminAppointments /></Protected>} />
      <Route path="/admin/settings" element={<Protected role="admin"><AdminSettings /></Protected>} />
      <Route path="/admin/clients/:user_id" element={<Protected role="admin"><AdminClientDetail /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <RouteSwitch />
            <Toaster />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}
